import { isFirefox } from 'react-device-detect';

export function extractHost(url) {
  const match = url.match(/^(?:https?:\/\/|www:\/\/)?([^/]+)/);
  return match ? match[1] : null;
}

export function getParentFrameUrl() {
  if (isFirefox) return document.referrer || window.origin;
  return window.frames?.location?.ancestorOrigins?.[0] || null;
}

// The URL a session should be ATTRIBUTED to. Inside a cross-origin iframe our
// own location is the SHARE url, so the customer's site never appeared in
// session telemetry ("Domain: share.streampixel.io/..." instead of the page
// that actually embeds us). Report the embedding page instead: the referrer
// keeps the parent's full path when its referrerpolicy allows; otherwise the
// top ancestor ORIGIN is the best a cross-origin iframe is permitted to know.
// Never throws — a sandboxed iframe degrades to our own href.
export function getAttributionUrl() {
  try {
    if (window.self === window.top) return window.location.href;
    const referrer = document.referrer;
    if (referrer && !referrer.startsWith(window.location.origin)) return referrer;
    const chain = window.location.ancestorOrigins;
    if (chain && chain.length) return chain[chain.length - 1];
    return referrer || window.location.href;
  } catch (_) {
    return window.location.href;
  }
}
